// ----------------------------------------------------------------------

export default function Dialog(theme) {
  return {
    MuiDialog: {
      styleOverrides: {
        root: {
          '& .MuiPaper-root': {
            borderRadius: theme.shape.borderRadius * 3.33, // ~20px
            boxShadow: theme.customShadows.dialog,
            backgroundColor: theme.palette.background.paper,
            color: theme.palette.text.primary,
          },
        },
      },
    },
    MuiDialogContent: {
      styleOverrides: {
        root: {
          padding: theme.spacing(3),
          '&.MuiDialogContent-root': {
            paddingTop: theme.spacing(3),
            paddingBottom: theme.spacing(3),
          },
        },
      },
    },
    MuiDialogTitle: {
      styleOverrides: {
        root: {
          padding: theme.spacing(3, 3, 2),
        },
      },
    },
    MuiDialogActions: {
      styleOverrides: {
        root: {
          padding: theme.spacing(2, 3, 3),
        },
      },
    },
  };
}

